import { captureException } from "@sentry/react";
import { useEffect } from "react";
import { Button } from "reactstrap";

interface CrashViewProps {
  error: any;
  type?: "drawer" | "full";
  resetErrorBoundary: () => void;
}

export const CrashViewComponent = ({ error }: { error: any }) => {
  const refresh = () => window.location.reload();

  useEffect(() => {
    captureException({ error, path: window.location.pathname });
  }, [error]);

  return (
    <div className="tw:p-6 tw:flex tw:justify-center tw:items-center">
      <div className="tw:text-center tw:max-w-md">
        <div className="tw:flex tw:justify-center tw:mb-2">
          <img src="/img/coffee.svg" className="tw:w-32 tw:h-32" />
        </div>
        <h2 className="tw:text-[1.2em] tw:text-dark">
          Oops! Something went wrong.
          <br /> Our code must have taken a coffee break.
        </h2>
        <span>{error.message}</span>
        <div className="tw:mt-3 tw:flex tw:justify-center">
          <Button color="primary" onClick={refresh}>
            Refresh
          </Button>
          <Button color="secondary" onClick={contactSupport}>
            Contact Support
          </Button>
        </div>
      </div>
    </div>
  );

  function contactSupport() {
    const message = `Hi Support Team,\n\nI encountered an issue with GrowthCloud. Here are the details:\n\nBest regards,`;
    window.open(
      `mailto:support@growthcloud.com?body=${encodeURI(
        message
      )}&subject=${encodeURI("Issue with GrowthCloud")}`,
      "_blank"
    );
  }
};

const CrashView = ({ error, type = "full" }: CrashViewProps) => {
  if (type === "drawer") {
    return (
      <DrawerContainer>
        <CrashViewComponent error={error} />
      </DrawerContainer>
    );
  }

  return (
    <div className="tw:flex tw:items-center tw:justify-center tw:w-screen tw:h-screen">
      <CrashViewComponent error={error} />
    </div>
  );
};

const DrawerContainer = ({ children }: any) => {
  return (
    <div className="w-100 h-100 mt-4 crash-drawer-container tw:w-full tw:h-full tw:mt-4 tw:relative tw:min-h-[200px]">
      <div className="tw:absolute tw:top-[50%] tw:left-[50%] tw:transform tw:translate-x-[-50%] tw:translate-y-[-50%]">
        {children}
      </div>
    </div>
  );
};

export default CrashView;
